import { useReduxState } from './Redux/useReduxState';

/**
 * Return auth state
 * @returns {boolean}
 */
export const useAuthRedux = (): [boolean, boolean] => {
    const { auth, user, loading } = useReduxState({
        auth: 'Auth.authenticated',
        loading: 'Auth.loading',
        user: 'User._user',
    });

    return [!!(auth && user), loading];
};
